import { ArrowBigUp } from "lucide-react";

interface CapsLockIndicatorProps {
  isCapsLockOn: boolean;
}

export function CapsLockIndicator({ isCapsLockOn }: CapsLockIndicatorProps) {
  if (!isCapsLockOn) return null;

  return (
    <p className="text-xs text-warning-hover flex items-center gap-1">
      <ArrowBigUp className="h-3.5 w-3.5" />
      Caps Lock is on
    </p>
  );
}
